import { createPerimeter } from 'vue-kindergarten';
import { isRole, canPerformAction, canAdd } from '../utilities/roleUtilities';
import { ACTIONS, ROLES } from '../../plugins/types';

export const RegistrationPerimeter = createPerimeter({
    purpose: 'registration',

    can: {
        view () {
            return isRole.admin(this.child);
        },

        read () {
            return canPerformAction({child: this.child, action: ACTIONS.READ});
        },

        add (role) {
            return canAdd({child: this.child, role}) && canPerformAction({child: this.child, action: ACTIONS.ADD});
        },

        roleCanAdd ({role, parentRole}) {
            return canAdd({child: {role: parentRole}, role});
        },

        update () {
            return canPerformAction({child: this.child, action: ACTIONS.UPDATE});
        },

        remove () {
            return canPerformAction({child: this.child, action: ACTIONS.REMOVE});
        },

        canThisRoleAddChildren (role) {
            switch ( role ) {
                case ROLES.ADMIN : return true;
                case ROLES.KEY_ACCOUNT : return true;
                case ROLES.SHOP_OWNER : return true;
                case ROLES.OPERATOR : return false;
                case ROLES.SALES : return true;
                case ROLES.PARTNER : return false;
                default: return false;
            }
        }


    }
});
